module.exports = __webpack_public_path__ + "static/media/logo.6b8ddf00.png";